export default {
  label: {
    notes: 'Label of maximize action for presentation',
    message: 'Maximize',
  },
};
